import { isPast } from 'date-fns'
import { PROPERTY_DATA_COLLECTOR } from '@components/Signup/constants'

/**
 * Check if the company is missing any needed info before doing things.
 */
export default function missingCompanyInfo(currentUser) {
  if (!['admin', 'manager'].includes(currentUser.role)) {
    return false
  }

  if (!currentUser.company) {
    return true
  }

  const isPDC = currentUser.user_type === PROPERTY_DATA_COLLECTOR
  const missingEO =
    !isPDC &&
    (!currentUser.company.eo_information ||
      !currentUser.company.eo_information.insurance_company ||
      !currentUser.company.eo_information.expiration_date ||
      !currentUser.company.eo_information.prior_acts ||
      !currentUser.company.eo_information.claim_limit ||
      !currentUser.company.eo_information.aggregate_limit)
  const expiredEO =
    !currentUser.company.eo_information ||
    !currentUser.company.eo_information.expiration_date ||
    (currentUser.company.eo_information.expiration_date && isPast(currentUser.company.eo_information.expiration_date))
  const missingAddress =
    !currentUser.company.address || !currentUser.company.city || !currentUser.company.state || !currentUser.company.zip
  const missingCoverage = !currentUser.company.company_coverage || !currentUser.company.company_coverage.length

  return missingEO || expiredEO || missingAddress || missingCoverage
}
